import { TaskType } from '@buildwise/libs/trackers/queries/useTrackerTasksQuery';
import { JAVA_SERVICE_ENDPOINTS, JavaAPI } from '@buildwise/libs/services';

export type TasksResponse = {
  tasks: TaskType[];
  pageNumber: number;
  totalElements: number;
  totalPages: number;
  userMap: {
    [key: string]: {
      displayName: string;
      id: string;
      isSME: boolean;
      primaryCompanyId: string;
      primaryCompanyName: string;
      profileImageURL: string;
      title: string;
      userName: string;
    }[];
  };
};

export type TrackerType = {
  active: boolean;
  companyId: string;
  createdAt: string | Date;
  createdBy: string;
  description: string;
  id: string;
  name: string;
  taskCount: number;
  type: string;
  configNameForFilters?: string;
  configNameForInputFields?: string;
  configNameForTasksStatus?: string;
  configNameForSubTasksStatus?: string;
};

export type TrackersResponse = {
  trackersList: TrackerType[];
  totalElements: number;
  userMap: {
    [key: string]: {
      displayName: string;
      id: string;
      isSME: boolean;
      primaryCompanyId: string;
      primaryCompanyName: string;
      profileImageURL: string;
      title: string;
      userName: string;
    }[];
  };
};

class TrackerAPI extends JavaAPI {
  public getTasksPagination(companyId: string, trackerId: string, page: number, size: number) {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });
    return this.get<TasksResponse>(
      `${JAVA_SERVICE_ENDPOINTS.GET_TASKS_BY_TRACKER_ID.replace(':companyId', companyId).replace(':trackerId', trackerId)}?${params.toString()}`,
    );
  }

  public addTask(companyId: string, payload: any) {
    return this.post(
      `${JAVA_SERVICE_ENDPOINTS.ADD_TASK.replace(':companyId', companyId)}`,
      payload,
    );
  }

  public editTask(companyId: string, taskId: string, payload: any) {
    return this.put(
      `${JAVA_SERVICE_ENDPOINTS.EDIT_TASK.replace(':companyId', companyId).replace(':taskId', taskId)}`,
      payload,
    );
  }

  public getAllTrackers(companyId: string) {
    return this.get(`${JAVA_SERVICE_ENDPOINTS.GET_ALL_TRACKERS.replace(':companyId', companyId)}`);
  }

  public getTrackerDetails(companyId: string, trackerId: string) {
    return this.get(
      `${JAVA_SERVICE_ENDPOINTS.GET_TRACKER_DETAILS.replace(':companyId', companyId).replace(':trackerId', trackerId)}`,
    );
  }

  public createTracker(companyId: string, payload: any) {
    return this.post(
      `${JAVA_SERVICE_ENDPOINTS.CREATE_TRACKER.replace(':companyId', companyId)}`,
      payload,
    );
  }

  public getCommentsByObjectId(
    companyId: string,
    objectId: string,
    objectName: string,
    objectType: string,
  ) {
    const params = new URLSearchParams({
      objectName: objectName.toString(),
      objectType: objectType.toString(),
    });
    return this.get(
      `${JAVA_SERVICE_ENDPOINTS.GET_COMMENTS_BY_OBJECT_ID.replace(':companyId', companyId).replace(':objectId', objectId)}?${params.toString()}`,
    );
  }

  public addCommentByObjectId(payload: any) {
    return this.post(JAVA_SERVICE_ENDPOINTS.ADD_COMMENT, payload);
  }
}

const trackerAPI = new TrackerAPI();
export default trackerAPI;
